import type { SearchResultContentSource, SearchResultContentType } from '../../types';
import { CheckboxGroup, MultiSelect } from '@workramp/ui';
import { I18n } from '~/common/explicit-exports';
import { MixPanel } from '~/common';
import { AdvancedSearchContentTypeOptions } from '../AdvancedSearchContentTypeOptions';
import { SearchResultContentSourceTypes, SearchResultContentTypes } from '../../constants';
import { useSearch } from '../../providers';
import { LearnerSearchMixpanelEvents } from '../../constants/mixpanel';

export const AdvancedSearchFilterType = () => {
  const TYPE = I18n.t('js.learner.advanced_search.filters.type');
  const TYPE_OPTIONS = I18n.t('js.learner.advanced_search.filters.type_options');

  const { contentTypes, setContentTypes, contentSources, setContentSources } = useSearch();

  const handleSelections = (selectedOptions: (SearchResultContentType | SearchResultContentSource)[]) => {
    const selectedTypes = selectedOptions.filter((so) => Object.values<string>(SearchResultContentTypes).includes(so));

    setContentTypes(selectedTypes as SearchResultContentType[]);
    const selectedSources = selectedOptions.filter((so) =>
      Object.values<string>(SearchResultContentSourceTypes).includes(so),
    );

    setContentSources(selectedSources as SearchResultContentSource[]);
    MixPanel.track(LearnerSearchMixpanelEvents.LEARNER_ADVANCED_SEARCH_SELECTS_TYPE_FILTER, {
      types: selectedOptions,
    });
  };

  const handleClear = () => {
    setContentTypes([]);
    setContentSources([]);
  };

  const numSelections = contentTypes.length + contentSources.length;
  const checkBoxGroupValue = [...contentTypes, ...contentSources];

  return (
    <MultiSelect label={TYPE} title={TYPE} numSelections={numSelections} onClear={handleClear}>
      <CheckboxGroup hideLabel label={TYPE_OPTIONS} value={checkBoxGroupValue} onChange={handleSelections}>
        <AdvancedSearchContentTypeOptions />
      </CheckboxGroup>
    </MultiSelect>
  );
};
